import React, { useEffect, useState } from "react";
import { Layout, Table } from "antd";
import "./Customers.scss";
import moment from "moment";

const CustomerOrders = ({ orders = [] }) => {
  const [customerOrders, setCustomerOrders] = useState([]);

  const columns = [
    {
      title: "Order Date",
      dataIndex: "order_date",
      key: "order_date",
      render: (e, record) => (
        <div>{moment(record.created_at).format("MM/DD/yyyy")}</div>
      ),
    },
    {
      title: "Item Name",
      dataIndex: "name",
      key: "name",
      //   width: 200,
      render: (e, record) => (
        <div className="">
          <div className="">
            {!record.seeAll
              ? record.order_items
                  .slice(0, 2)
                  .map((item) => (
                    <div key={item.menu_item?.id}>{item?.order_item?.quantity} x {item.menu_item?.name}</div>
                  ))
              : record.order_items.map((item) => (
                  <div key={item.menu_item?.id}>{item?.order_item?.quantity} x {item.menu_item?.name}</div>
                ))}
          </div>
          {record.order_items.length > 2 && (
            <div
              className="see-all-btn"
              onClick={(event) => handleSeeAll(record, event)}
            >
              {" "}
              {!record.seeAll
                ? `${
                    record.order_items.length > 2
                      ? "+ " + (record.order_items.length - 2) + " Items - "
                      : ""
                  }see all`
                : "see less"}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Total Price",
      dataIndex: "email",
      key: "email",
      render: (e, record) => <div className="view-profile">$ {record.price}</div>,
    },
  ];

  const handleSeeAll = (record, event) => {
    event.stopPropagation();
    const modified = orders.map((item) => {
      if (item.id == record.id) {
        const obj = {
          ...item,
          seeAll: record.seeAll ? !record.seeAll : true,
        };
        return obj;
      } else return item;
    });
    setCustomerOrders(modified);
  };

  useEffect(() => {
    setCustomerOrders(orders);
  }, [orders]);

  return (
    <Layout className="">
      <div className="site-layout-background" style={{padding: "0px 5px"}}>
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={customerOrders}
          onRow={(record, rowIndex) => {
            return {};
          }}
        />
      </div>
    </Layout>
  );
};

export default CustomerOrders;
